export default __webpack_public_path__ + "static/media/e4.4a48e70f.jpeg";